import React, { useRef } from "react";
import { buttonStyle, cardStyle, chipStyle, muted, TAB_META } from "./AdminIntelligenceShared";

function statusChip(status) {
  const value = String(status || "").toLowerCase();
  if (value === "running") return { label: "Running", style: { background: "#fef3c7", color: "#b45309", borderColor: "#fde68a" } };
  if (value === "error") return { label: "Error", style: { background: "#fee2e2", color: "#b91c1c", borderColor: "#fecaca" } };
  return null;
}

function formatSessionTime(value) {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
}

function sanitizeTitle(title, currentTab) {
  const value = String(title || "").replace(/[^\x00-\x7F]/g, " ").replace(/\s+/g, " ").trim();
  if (!value) return "Untitled";
  if (currentTab === "tab3" && /^Content run\b/i.test(value)) return "Content run";
  if (currentTab === "tab4" && /^Investigation\b/i.test(value)) return "Investigation";
  return value;
}

export default function AdminSessionSidebar({
  currentTab,
  sessions,
  activeSessionId,
  loading,
  hasMore,
  onLoadMore,
  onSelect,
  onDelete,
  onNew,
}) {
  const listRef = useRef(null);
  const tabLabel = TAB_META[currentTab]?.label || "Intelligence";
  const newLabel = currentTab === "tab1"
    ? "New conversation"
    : currentTab === "tab2"
      ? "New report"
      : currentTab === "tab3"
        ? "New generation"
        : "New scan";

  function handleScroll() {
    const el = listRef.current;
    if (!el || !hasMore || loading) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 80) onLoadMore?.();
  }

  return (
    <div style={{ width: 260, minWidth: 260, maxWidth: 260, borderRight: "1px solid #e5e7eb", background: "#fff", display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{ padding: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ fontSize: 12, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>{tabLabel}</div>
        <button style={{ ...buttonStyle, width: "100%", background: "#0f172a", color: "#fff", borderColor: "#0f172a" }} onClick={onNew}>{newLabel}</button>
      </div>

      <div ref={listRef} onScroll={handleScroll} style={{ flex: 1, overflowY: "auto", padding: 12, display: "grid", gap: 8 }}>
        {sessions.map((session) => {
          const active = session.id === activeSessionId;
          const badge = statusChip(session.status);
          return (
            <div
              key={session.id}
              style={{
                ...cardStyle,
                padding: 12,
                borderRadius: 12,
                cursor: "pointer",
                borderColor: active ? TAB_META[currentTab]?.theme || "#1d4ed8" : "#e5e7eb",
                boxShadow: active ? `inset 3px 0 0 ${TAB_META[currentTab]?.theme || "#1d4ed8"}` : "0 6px 18px rgba(15,23,42,0.04)",
                background: active ? "#f8fafc" : "#fff",
              }}
              onClick={() => onSelect?.(session.id)}
            >
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "flex-start" }}>
                <div style={{ fontWeight: 800, fontSize: 14, lineHeight: 1.4, wordBreak: "break-word" }}>{sanitizeTitle(session.title, currentTab)}</div>
                <button
                  style={{ border: 0, background: "transparent", color: "#94a3b8", cursor: "pointer", fontSize: 16, lineHeight: 1 }}
                  onClick={(e) => { e.stopPropagation(); if (window.confirm("Delete this session permanently?")) onDelete?.(session.id); }}
                  title="Delete session"
                >
                  Delete
                </button>
              </div>
              <div style={{ ...muted, marginTop: 6 }}>{formatSessionTime(session.updated_at || session.created_at)}</div>
              {badge ? <span style={{ ...chipStyle, marginTop: 8, ...badge.style }}>{badge.label}</span> : null}
            </div>
          );
        })}
        {!loading && sessions.length === 0 ? <div style={{ ...muted, padding: 8 }}>No sessions yet.</div> : null}
        {loading ? <div style={{ ...muted, padding: 8 }}>Loading...</div> : null}
      </div>
    </div>
  );
}

